import jsdk from '../../jsdk';
import t from 'tcomb';
import UUID from './UUID';
import Component_Option from './Component_Option';
import Select_Render_As from './Select_Render_As';
import Select_Other from './Select_Other';
import Str_Schema from './Str_Schema';
import Select_Component_Style from './style/Select_Component_Style';
import shuffle from 'lodash/collection/shuffle';

const Ord = t.enums.of(['asc', 'desc', 'random']);

const Select_Component = t.struct({
  id: UUID,
  name: t.String,
  style: Select_Component_Style,
  options: t.list(Component_Option),
  schema: Str_Schema,
  render_as: Select_Render_As,
  order: t.maybe(Ord),
  other: t.maybe(Select_Other),
  other_label: t.maybe(t.String)
}, 'Select_Component');


Select_Component.prototype.to_form = function() {
  // converto le options dal formato del bo a quello che
  // capisce il web e poi le ordino come ha scelto l'operatore

  var options = this.options.map(function(option) {
    return [option.k, option.v];
  });

  if (this.order) {
    if (this.order === 'random') {
      options = shuffle(options);
    } else {
      options = options.sort(jsdk.by(1, this.order === 'desc'));
    }
  }

  return {
    type: 'reducer/select',
    id: this.id,
    options: jsdk.copy(options),
    style: this.style,
    schema: this.schema,
    render_as: this.render_as,
    other: this.other,
    other_label: this.other_label
  };
};

module.exports = Select_Component;



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Select_Component.js
 **/